import axionIns from "../axios";

const post = async (url, payload) => {
  return await axionIns
    .post(url, JSON.stringify(payload))
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return response;
    });
};

const postForm = async (url, payload) => {
  return await axionIns
    .post(url, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response)
    .catch((response) => response);
};

const upload = async (url, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axionIns
    .post(url, formData)
    .then((response) => response)
    .catch((response) => response);
};

const get = async (url, config = {}) => {
  return axionIns
    .get(url, config)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return response;
    });
};

const put = async (url, payload) => {
  return axionIns
    .put(url, JSON.stringify(payload))
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return response;
    });
};

const deleteApi = async (url, payload) => {
  return axionIns
    .delete(url, payload)
    .then((response) => {
      return response;
    })
    .catch((response) => {
      return response;
    });
};

const exportObject = {
  post,
  postForm,
  upload,
  get,
  put,
  deleteApi,
};
export default exportObject;
